import { DeleteIcon, EditIcon } from 'assets/images'
import { ButtonsContainer, StyledIcon, StyledValue } from './EditDeleteButton.styles'
import { TEditDeleteButton } from './EditDeleteButton.types'

const EditDeleteButton = ({ type, value, onClick }: TEditDeleteButton) => {
  let icon
  switch (type) {
    case 'edit':
      icon = EditIcon
      break
    case 'delete':
      icon = DeleteIcon
      break
    case 'resolve':
      icon = DeleteIcon
      break
    default:
      icon = null
  }

  const color = type === 'resolve' ? 'green' : type === 'edit' ? '#2080F6' : '#e73f3f'

  return (
    <ButtonsContainer onClick={onClick}>
      {icon && type !== 'resolve' && <StyledIcon src={icon} />}
      <StyledValue $color={color}>{value}</StyledValue>
    </ButtonsContainer>
  )
}

export default EditDeleteButton
